import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { var_api } from "../../../constant";

const PurchaseOrderMaster = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [poData, setPoData] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [variantInputs, setVariantInputs] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  // ===== Status Update Modals =====
const [showPaymentModal, setShowPaymentModal] = useState(false);
const [showOrderModal, setShowOrderModal] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("");
const [selectedOrderStatus, setSelectedOrderStatus] = useState("");
const [agencyData, setAgencyData] = useState([]);
const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [formDataDetails, setFormDataDetails] = useState({
    product_id: "",
    variant_id: "",
  });

  // LocalStorage values
  const business_id = localStorage.getItem("business_id") || 2;
  const city_id = localStorage.getItem("city_id") || 2;
  const warehouse_id = localStorage.getItem("warehouse_id") || 1;
  const [quotationData, setQuotationData] = useState([]);
const [quotationDetailData, setQuotationDetailData] = useState([]);

 const [selectedQuotationId, setSelectedQuotationId] = useState(null);
const fetchQuotationData = async () => {
  setPageLoading(true);
  try {
    const res = await axios.get(`${var_api}sa_veemart_quotation/get`);
    const data = Array.isArray(res.data)
      ? res.data
      : res.data.data || [];
    setQuotationData(data);
  } catch (error) {
    toast.error("Failed to fetch quotations");
  } finally {
    setPageLoading(false); // stop loader
  }
};
const fetchQuotationDetailData = async (quotationId) => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_quotation_detail/get`);
    const allData = Array.isArray(res.data)
      ? res.data
      : res.data.data || [];

    // Filter only items for the selected quotation_id
    const filtered = allData.filter(
      (item) => String(item.quotation_id) === String(quotationId)
    );
    setQuotationDetailData(filtered);
  } catch (error) {
    console.error("Failed to fetch quotation details:", error);
    toast.error("Failed to fetch quotation details");
  }
};
useEffect(() => {
  fetchQuotationData();
}, []);


  // ===== Fetch Product & Variant Data =====
  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };

  // ✅ FETCH EXISTING PURCHASE ORDERS (API Integration)
  const fetchPOData = async () => {
             setPageLoading(true);

    try {
      const res = await axios.get(`${var_api}sa_veemart_po/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setPoData(data);
    } catch (err) {
      toast.error("Failed to fetch Purchase Orders");
    }finally {
      setPageLoading(false); // stop loader
    }
  };

  useEffect(() => {
    fetchProductData();
    fetchVariantData();
    fetchPOData();
    fetchAgencyData();
  }, []);

  const combinedOptions = productData.flatMap((product) =>
    variantData
      .filter((variant) => variant.product_id === product.id)
      .map((variant) => ({
      label: `${product.product_name} (${product.veemart_product_code || "N/A"}) - ${variant.variant_name}`,
        value: { product_id: product.id, variant_id: variant.id },
      }))
  );

  // ====== Handle Add Click ======
  const handleAddClick = () => {
    setVariantInputs([]);
    setShowDetailsModal(true);
    fetchProductData();
    fetchAgencyData();
  };
// const handleAddClick = () => {
//   // Clear all form data when opening new modal
//   setVariantInputs([]);
//   setFormDataDetails({ product_id: "", variant_id: "" });
//   setSelectedQuotationId(null);
//   setQuotationDetailData([]);
//   setSelectedSupplier(null);
//   setIsEditing(false);
//   setEditId(null);

//   // Now open modal
//   setShowDetailsModal(true);

//   // Fetch fresh data if needed
//   fetchProductData();
//   fetchAgencyData();
// };

  // ====== Add Product Variant Row ======
const handleAddVariant = () => {
  if (!formDataDetails.product_id || !formDataDetails.variant_id) {
    toast.error("Please select both Product and Variant");
    return;
  }

  const selectedProduct = productData.find(
    (p) => p.id === formDataDetails.product_id
  );
  const selectedVariant = variantData.find(
    (v) => v.id === formDataDetails.variant_id
  );

  const exists = variantInputs.some(
    (v) => v.variant_id === formDataDetails.variant_id
  );
  if (exists) {
    toast.warning("Variant already added!");
    return;
  }

  // ✅ Find quotation detail for this product+variant
  const quotationDetail = quotationDetailData.find(
    (qd) =>
      Number(qd.product_id) === Number(formDataDetails.product_id) &&
      Number(qd.variant_id) === Number(formDataDetails.variant_id)
  );

  const newRow = {
    product_id: selectedProduct.id,
    product_name: selectedProduct.product_name,
    variant_id: selectedVariant.id,
    variant_name: selectedVariant.variant_name,
    uom: selectedVariant.uom || "-",
    gross_weight: selectedVariant.gross_weight || "-",
    net_weight: selectedVariant.net_weight || "-",
    qty: quotationDetail?.qty || "",
    unit_price: quotationDetail?.unit_price || "",
    discount: quotationDetail?.discount || "",
    tax_percent: quotationDetail?.tax_percent || "",
    tax_amount: quotationDetail
      ? ((quotationDetail.qty * quotationDetail.unit_price - 
          (quotationDetail.qty * quotationDetail.unit_price * (quotationDetail.discount || 0)/100)) *
          (quotationDetail.tax_percent || 0) / 100
        ).toFixed(2)
      : "",
    total_price: quotationDetail
      ? (
          (quotationDetail.qty * quotationDetail.unit_price -
            (quotationDetail.qty * quotationDetail.unit_price * (quotationDetail.discount || 0)/100)) +
          ((quotationDetail.qty * quotationDetail.unit_price -
            (quotationDetail.qty * quotationDetail.unit_price * (quotationDetail.discount || 0)/100)) *
            (quotationDetail.tax_percent || 0) / 100)
        ).toFixed(2)
      : "",
    remarks: quotationDetail?.remarks || "",
  };

  setVariantInputs((prev) => [...prev, newRow]);
};

 const fetchAgencyData = async () => {
  try {
    const res = await axios.get(`${var_api}ci_veemart_supplier_master/get`);
    const agencies = Array.isArray(res.data) ? res.data : res.data.data || [];
    setAgencyData(agencies);
  } catch (err) {
    console.error("Failed to fetch suppliers:", err);
    toast.error("Failed to fetch supplier data");
  }
};
  // ====== Handle Submit Purchase Order (API Integration) ======
  const handleDetailsSubmit = async (e) => {
    e.preventDefault();
    if (variantInputs.length === 0) {
      toast.error("Please add at least one variant!");
      return;
    }

    const newPO = {
      business_id,
      city_id,

      supplier_id: Number(selectedSupplier),
      warehouse_id,
      // po_number: generatePONumber(),
      po_date: new Date().toISOString().slice(0, 10),
      expected_delivery_date: new Date().toISOString().slice(0, 10),
      total_amount: 0,
      payment_status: 0,
      order_status: 0,
      order_type: 0,
      remarks: "",
      details: variantInputs,
    };

    try {
      const res = await axios.post(`${var_api}sa_veemart_po/post`, newPO);
      toast.success("Purchase Order saved!");

      // After successful save, refresh data
      fetchPOData();

      // Store info in localStorage
      localStorage.setItem("po_id", res.data.id || newPO.id);
      localStorage.setItem("po_number", newPO.po_number);
      localStorage.setItem("po_date", newPO.po_date);
      localStorage.setItem("payment_status", newPO.payment_status);
      localStorage.setItem("order_status", newPO.order_status);

      setShowDetailsModal(false);
      navigate(`/purchase-order-details?po_id=${encodeURIComponent(res.data.id || newPO.id)}`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to save Purchase Order");
    }
  };
const handleResetForm = () => {
  setVariantInputs([]);
  setFormDataDetails({ product_id: "", variant_id: "" });
  setIsEditing(false);
  setEditId(null);
  toast.info("Form has been reset");
};
// Helper: Format date as dd-mm-yyyy
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

  // ====== Status Badge ======
 const getPaymentStatus = (status, row) => {
  switch (Number(status)) {
    case 0:
      return (
        <span
          className="badge bg-warning text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedRow(row);
            setSelectedPaymentStatus("");
            setShowPaymentModal(true);
          }}
        >
          Pending
        </span>
      );
    case 1:
      return <span className="badge bg-success">Paid</span>;
    case 2:
      return <span className="badge bg-info text-dark">Partial</span>;
    default:
      return <span className="badge bg-secondary">Unknown</span>;
  }
};

const getOrderStatus = (status, row) => {
  switch (Number(status)) {
    case 0:
      return (
        <span
          className="badge bg-secondary"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedRow(row);
            setSelectedOrderStatus("");
            setShowOrderModal(true);
          }}
        >
          Pending
        </span>
      );
    case 1:
      return <span className="badge bg-success">Approved</span>;
    case 2:
      return <span className="badge bg-danger">Cancelled</span>;
    default:
      return <span className="badge bg-light text-dark">Unknown</span>;
  }
};
const getSupplierName = (id) => {
  const supplier = agencyData.find((a) => a.id === id);
  return supplier ? supplier.supplier_name : "-";
};

  const filteredPOData = poData.filter((item) =>
    item.po_number?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Card>
        <Card.Body>
            {pageLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
          <div className="d-flex justify-content-end mb-3 gap-2">
             <Button
                                variant="outline-success"
                                onClick={() => navigate("/grn")}
                                title="grn"
                              >
                                <i className="fas fa-external-link-alt"></i>
                              </Button>
            <input
              type="text"
              className="form-control w-auto"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
            <Button variant="secondary" onClick={handleAddClick}>
              Add
            </Button>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>PO Number</th>
                  <th>PO Date</th>
                                <th>Supplier </th>
                  <th>Payment Status</th>
                  <th>Order Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredPOData.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      No records found
                    </td>
                  </tr>
                ) : (
                  filteredPOData.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{idx + 1}</td>
                      <td>{item.po_number}</td>
<td>{formatDate(item.po_date)}</td>
 <td>{getSupplierName(item.supplier_id)}</td>
                     <td>{getPaymentStatus(item.payment_status, item)}</td>
<td>{getOrderStatus(item.order_status, item)}</td>

                      <td>
                        <button
                          className="btn shadow btn-xs sharp"
                          style={{ backgroundColor: "#6c757d", color: "white" }}
                          title="View Purchase Order"
                          onClick={() => {
                            localStorage.setItem("sa_veemart_po_id", item.id);
                            localStorage.setItem("po_number", item.po_number);
                            localStorage.setItem("po_date", item.po_date);
                            localStorage.setItem("payment_status", item.payment_status);
      localStorage.setItem("order_status", item.order_status);
                            navigate(
                              `/order-details?po_id=${encodeURIComponent(
                                item.id
                              )}`
                            );
                          }}
                        >
                          <i className="fas fa-file-invoice"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          </>
          )}
        </Card.Body>
      </Card>

      {/* ✅ Purchase Order Details Modal */}
        <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add PO Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleDetailsSubmit}>
            <Row className="align-items-end">
                     <Col md={5}>
                  <Form.Group>
                    <Form.Label>Supplier</Form.Label>
                    <Select
                      options={agencyData.map((a) => ({
                        label: a.supplier_name,
                        value: a.id,
                      }))}
                      value={
                        selectedSupplier
                          ? {
                              label:
                                agencyData.find((a) => a.id === selectedSupplier)?.supplier_name ||
                                "",
                              value: selectedSupplier,
                            }
                          : null
                      }
                      onChange={(selected) => {
                        setSelectedSupplier(selected ? selected.value : null);
                      }}
                      placeholder="Select Supplier"
                      isClearable
                      isSearchable
                    />
                  </Form.Group>
                </Col>
{/* <Col md={5}>
  <Form.Group>
    <Form.Label>Supplier</Form.Label>
    <Form.Control
      type="text"
      value={
        selectedSupplier
          ? agencyData.find((a) => a.id === selectedSupplier)?.supplier_name || ""
          : ""
      }
      placeholder="Supplier"
      readOnly
      disabled
    />
  </Form.Group>
</Col> */}

 <Col md={5}>
   <Form.Group>
<Form.Label>Quotation Number</Form.Label>
<Select
  options={quotationData.map((q) => ({
    label: q.quotation_number || `QTN-${q.id}`,
    value: q.id,
  }))}
  placeholder="Select Quotation Number"
  isSearchable
  isClearable
  value={
    selectedQuotationId
      ? {
          label:
            quotationData.find((q) => q.id === selectedQuotationId)
              ?.quotation_number || `QTN-${selectedQuotationId}`,
          value: selectedQuotationId,
        }
      : null
  }
  onChange={(selected) => {
    if (selected) {
      setSelectedQuotationId(selected.value);
      localStorage.setItem("quotation_id", selected.value);
      fetchQuotationDetailData(selected.value); // ✅ get quotation items
    } else {
      setSelectedQuotationId(null);
      setQuotationDetailData([]);
    }
  }}

//   onChange={(selected) => {
//   if (selected) {
//     setSelectedQuotationId(selected.value);
//     localStorage.setItem("quotation_id", selected.value);
//     fetchQuotationDetailData(selected.value); // ✅ get quotation items

//     // ✅ Auto-select supplier based on quotation
//     const selectedQuotation = quotationData.find(
//       (q) => q.id === selected.value
//     );

//     if (selectedQuotation && selectedQuotation.supplier_id) {
//       setSelectedSupplier(selectedQuotation.supplier_id);
//     }
//   } else {
//     setSelectedQuotationId(null);
//     setQuotationDetailData([]);
//     setSelectedSupplier(null);
//   }
// }}

/>

</Form.Group>

  </Col>







             <Col md={5}>
            <Form.Group>
             <Form.Label>Product + Variant</Form.Label>
       <Select
  options={
    selectedQuotationId && quotationDetailData.length > 0
      ? quotationDetailData.map((item) => {
          const product = productData.find((p) => p.id === item.product_id);
          const variant = variantData.find((v) => v.id === item.variant_id);
          return {
            label: `${product?.product_name || "Unknown"} - ${
              variant?.variant_name || "Unknown"
            }`,
            value: {
              product_id: item.product_id,
              variant_id: item.variant_id,
            },
          };
        })
      : []
  }
  onChange={(selected) =>
    setFormDataDetails({
      product_id: selected.value.product_id,
      variant_id: selected.value.variant_id,
    })
  }
  placeholder={
    selectedQuotationId
      ? "Select Product & Variant from Quotation"
      : "Select a Quotation first"
  }
  isDisabled={!selectedQuotationId}
  isSearchable
/>


           </Form.Group>
           
           </Col>

              <Col md={2}>
                <Button
                  type="button"
                  variant="success"
                  onClick={handleAddVariant}
                >
                  <i className="fas fa-plus"></i> Add
                </Button>
              </Col>
            </Row>

            {variantInputs.length > 0 && (
              <>
           <div className="table-responsive mt-3">
  <table className="table table-bordered">
    <thead className="table-light">
      <tr>
        <th style={{ width: "4%" }}>#</th>
    <th style={{ width: "15%" }}>Product</th>
    <th style={{ width: "15%" }}>Variant</th>
    <th style={{ width: "8%" }}>UOM</th>
    <th style={{ width: "1%" }}>Gross/Net</th> {/* reduced */}
    <th style={{ width: "15%" }}>Qty</th>       {/* increased */}
    <th style={{ width: "10%" }}>Unit Price</th>
    <th style={{ width: "8%" }}>Discount</th>
    <th style={{ width: "8%" }}>Tax %</th>
    <th style={{ width: "8%" }}>Tax Amount</th>
    <th style={{ width: "10%" }}>Total Price</th>
    <th style={{ width: "12%" }}>Remarks</th>
      </tr>
    </thead>
    <tbody>
      {variantInputs.map((v, idx) => (
        <tr key={idx}>
          <td>{idx + 1}</td>
          <td>{v.product_name}</td>
          <td>{v.variant_name}</td>
          <td>{v.uom}</td>
          <td>
            {v.gross_weight}/{v.net_weight}
          </td>

          {/* Qty */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.qty}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].qty = e.target.value;

                  // auto-calculate total price when qty changes
                  const unitPrice = Number(updated[idx].unit_price || 0);
                  const discount = Number(updated[idx].discount || 0);
                  const tax = Number(updated[idx].tax_percent || 0);

                  const subtotal = unitPrice * Number(e.target.value || 0);
                  const afterDiscount = subtotal - (subtotal * discount) / 100;
                  const taxAmount = (afterDiscount * tax) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Unit Price */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.unit_price || ""}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].unit_price = e.target.value;

                  // recalc total
                  const qty = Number(updated[idx].qty || 0);
                  const discount = Number(updated[idx].discount || 0);
                  const tax = Number(updated[idx].tax_percent || 0);
                  const subtotal = qty * Number(e.target.value || 0);
                  const afterDiscount = subtotal - (subtotal * discount) / 100;
                  const taxAmount = (afterDiscount * tax) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Discount */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.discount || ""}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].discount = e.target.value;

                  const qty = Number(updated[idx].qty || 0);
                  const unitPrice = Number(updated[idx].unit_price || 0);
                  const tax = Number(updated[idx].tax_percent || 0);
                  const subtotal = qty * unitPrice;
                  const afterDiscount = subtotal - (subtotal * Number(e.target.value || 0)) / 100;
                  const taxAmount = (afterDiscount * tax) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Tax % */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.tax_percent || ""}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].tax_percent = e.target.value;

                  const qty = Number(updated[idx].qty || 0);
                  const unitPrice = Number(updated[idx].unit_price || 0);
                  const discount = Number(updated[idx].discount || 0);
                  const subtotal = qty * unitPrice;
                  const afterDiscount = subtotal - (subtotal * discount) / 100;
                  const taxAmount = (afterDiscount * Number(e.target.value || 0)) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Tax Amount (auto) */}
          <td>
            <Form.Control
              type="text"
              value={v.tax_amount || "0.00"}
              readOnly
              disabled
            />
          </td>

          {/* Total Price (auto) */}
          <td>
            <Form.Control
              type="text"
              value={v.total_price || "0.00"}
              readOnly
              disabled
            />
          </td>

          {/* Remarks */}
          <td>
            <Form.Control
              type="text"
              value={v.remarks}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].remarks = e.target.value;
                  return updated;
                })
              }
            />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


                              <div className="d-flex justify-content-end gap-2 mt-3">
                 <Button type="submit" variant="secondary" disabled={loading}>
                   {loading ? (
                     <>
                       <span
                         className="spinner-border spinner-border-sm me-2"
                         role="status"
                         aria-hidden="true"
                       ></span>
                       {isEditing ? "Updating..." : "Submitting..."}
                     </>
                   ) : (
                     isEditing ? "Update" : "Submit"
                   )}
                 </Button>
               
                 <Button variant="warning" type="button" onClick={handleResetForm} disabled={loading}>
                   <i className="fas fa-undo"></i> Reset
                 </Button>
               
                 <Button variant="danger" onClick={() => setShowDetailsModal(false)} disabled={loading}>
                   Cancel
                 </Button>
               </div>
              </>
            )}
          </Form>
        </Modal.Body>
      </Modal>
{/* ✅ Payment Status Modal */}
<Modal
  show={showPaymentModal}
  onHide={() => setShowPaymentModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Update Payment Status</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <div className="mb-3">
        <Form.Check
          type="radio"
          label="Paid"
          name="paymentStatus"
          value="1"
          checked={selectedPaymentStatus === "1"}
          onChange={(e) => setSelectedPaymentStatus(e.target.value)}
        />
        <Form.Check
          type="radio"
          label="Partial"
          name="paymentStatus"
          value="2"
          checked={selectedPaymentStatus === "2"}
          onChange={(e) => setSelectedPaymentStatus(e.target.value)}
        />
      </div>
      <div className="text-end">
       
        <Button
          variant="warning"
          onClick={async () => {
            if (!selectedPaymentStatus) {
              toast.warning("Please select a status!");
              return;
            }
            try {
              await axios.put(`${var_api}sa_veemart_po/update-payment-status`, {
                id: selectedRow.id,
                payment_status: Number(selectedPaymentStatus),
              });
              toast.success("Payment status updated!");
              setShowPaymentModal(false);
              fetchPOData();
            } catch (err) {
              toast.error("Failed to update payment status");
            }
          }}
        >
          Update
        </Button>
         <Button
          variant="danger"
          onClick={() => setShowPaymentModal(false)}
          className="me-2"
        >
          Cancel
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>
{/* ✅ Order Status Modal */}
<Modal
  show={showOrderModal}
  onHide={() => setShowOrderModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Update Order Status</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <div className="mb-3">
        <Form.Check
          type="radio"
          label="Approved"
          name="orderStatus"
          value="1"
          checked={selectedOrderStatus === "1"}
          onChange={(e) => setSelectedOrderStatus(e.target.value)}
        />
        <Form.Check
          type="radio"
          label="Cancelled"
          name="orderStatus"
          value="2"
          checked={selectedOrderStatus === "2"}
          onChange={(e) => setSelectedOrderStatus(e.target.value)}
        />
      </div>
      <div className="text-end">
      
        <Button
          variant="warning"
          onClick={async () => {
            if (!selectedOrderStatus) {
              toast.warning("Please select a status!");
              return;
            }
            try {
              await axios.put(`${var_api}sa_veemart_po/update-order-status`, {
                id: selectedRow.id,
                order_status: Number(selectedOrderStatus),
              });
              toast.success("Order status updated!");
              setShowOrderModal(false);
              fetchPOData();
            } catch (err) {
              toast.error("Failed to update order status");
            }
          }}
        >
          Update
        </Button>
       
         <Button
          variant="danger"
          onClick={() => setShowPaymentModal(false)}
          className="me-2"
        >
          Cancel
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

      <ToastContainer />
    </>
  );
};

export default PurchaseOrderMaster;
